import {
  handleAddLocations,
  handleAddMachines,
  handleAddSpecificLocations,
  handleLocationSelect,
  handleMachineSelect,
  handleMachineSelectAlt,
  handleMachineSelectWithSpecLocationAlt,
  handleSelectAll,
  handleSpecificLocationSelect,
} from 'shared/slice/masterControlSelectSlice';

const getDevices = (location) => location?.devices || location || {};

const setAllMachines = (locationMachines, value) =>
  locationMachines?.map((el) =>
    Array.isArray(el) ? el.map(() => value) : value
  );

const withValue = (list = [], value, isSelected) =>
  isSelected
    ? list.includes(value)
      ? [...list]
      : [...list, value]
    : list.filter((el) => el !== value);

const sameMachine = (entry, target) =>
  entry.length === target.length && entry.every((el, i) => el === target[i]);

const remainingMachineDescriptors = (locationKey, location, locationMachines) => {
  const list = [];

  if (location?.isSpecificLocation) {
    Object.entries(location.subLocations || {}).forEach(
      ([subKey, subLocation], subIdx) => {
        Object.keys(getDevices(subLocation)).forEach((device, deviceIdx) => {
          if (locationMachines?.[subIdx]?.[deviceIdx]) {
            list.push({
              location: locationKey,
              specificLocation: subKey,
              device,
            });
          }
        });
      }
    );
  } else {
    Object.keys(getDevices(location)).forEach((device, deviceIdx) => {
      if (locationMachines?.[deviceIdx]) {
        list.push({ location: locationKey, specificLocation: null, device });
      }
    });
  }

  return list;
};

const toMachineEntry = ({ location, specificLocation, device }) =>
  specificLocation ? [location, specificLocation, device] : [location, device];

const mergeMachineEntries = (list = [], descriptors) =>
  descriptors.reduce((result, descriptor) => {
    const entry = toMachineEntry(descriptor);
    return result.some((el) => sameMachine(el, entry))
      ? result
      : [...result, entry];
  }, [...list]);

export const coversSelection = (target, entry) =>
  entry.location === target.location &&
  (target.specificLocation == null ||
    entry.specificLocation === target.specificLocation) &&
  (target.device == null || entry.device === target.device);

export const useSelectSwitchesDisplay = (
  option,
  machine,
  extraOption,
  machineIndex,
  specificLocations,
  swt,
  data,
  allSelectBoxData,
  dispatch
) => {
  const locations = Object.keys(data || {});
  const {
    isAllSelected,
    isLocationSelected,
    isSpecificLocationSelected,
    isMachineSelected,
    selectedSpecificLocations,
    selectedMachines,
    selectedLocations,
  } = allSelectBoxData;
  const selectedList = [];
  let expanded = [];
  let select;

  if (option === 'all') {
    select = !isAllSelected;

    dispatch(handleSelectAll({ switch: swt, status: select }));
    dispatch(
      handleLocationSelect({
        switch: swt,
        arr: isLocationSelected.map(() => select),
      })
    );
    dispatch(
      handleSpecificLocationSelect({
        switch: swt,
        arr: isSpecificLocationSelected.map((el) => el.map(() => select)),
      })
    );

    const individualArr = Object.values(data || {}).map((location) => {
      if (location?.isSpecificLocation) {
        return Object.values(location.subLocations || {}).map((subLocation) =>
          Object.keys(getDevices(subLocation)).map(() => select)
        );
      }

      return Object.keys(getDevices(location)).map(() => select);
    });

    dispatch(handleMachineSelect({ switch: swt, arr: individualArr }));

    if (!select) {
      dispatch(handleAddLocations({ switch: swt, arr: [] }));
      dispatch(handleAddSpecificLocations({ switch: swt, arr: [] }));
      dispatch(handleAddMachines({ switch: swt, arr: [] }));
    }

    locations.forEach((locKey) => {
      selectedList.push({
        location: locKey,
        specificLocation: null,
        device: null,
      });
    });
  } else if (option !== 'all' && machine === undefined) {
    const index = locations.indexOf(option);
    select = !isLocationSelected[index];

    const arr = [...isLocationSelected];
    arr[index] = select;
    dispatch(handleLocationSelect({ switch: swt, arr }));

    if (!select) {
      dispatch(handleSelectAll({ switch: swt, status: false }));
    }

    const exitingSpecLocationsValue = Object.values(data || {}).filter(
      (el) => el?.isSpecificLocation
    );
    const newIsSpecificLocationSelected = [];

    exitingSpecLocationsValue.forEach((specLocationTitle) => {
      const tempArr = [];
      newIsSpecificLocationSelected.push(tempArr);

      if (data?.[option]?.subLocations) {
        Object.keys(data[option].subLocations).forEach((el, specIndex) => {
          if (el === Object.keys(specLocationTitle.subLocations || {})[specIndex]) {
            tempArr.push(select);
          } else {
            tempArr.push(false);
          }
        });
      }
    });

    dispatch(
      handleSpecificLocationSelect({
        switch: swt,
        arr: newIsSpecificLocationSelected,
      })
    );

    const machineNewArr = setAllMachines(isMachineSelected[index], select);
    const copyArr = [...isMachineSelected];
    copyArr[index] = machineNewArr;
    dispatch(handleMachineSelect({ switch: swt, arr: copyArr }));

    dispatch(
      handleAddLocations({
        switch: swt,
        arr: withValue(selectedLocations, option, select),
      })
    );

    if (!select) {
      const subKeys = Object.keys(data?.[option]?.subLocations || {});
      dispatch(
        handleAddSpecificLocations({
          switch: swt,
          arr: selectedSpecificLocations.filter((el) => !subKeys.includes(el)),
        })
      );
      dispatch(
        handleAddMachines({
          switch: swt,
          arr: selectedMachines.filter((el) => el[0] !== option),
        })
      );
    }

    selectedList.push({
      location: option,
      specificLocation: null,
      device: null,
    });
  } else if (option !== 'all' && machine === 'isSpecificLocation') {
    let index;
    specificLocations.forEach((el, i) => {
      if (el.includes(extraOption)) {
        index = i;
      }
    });

    select = !isSpecificLocationSelected[index]?.[machineIndex];

    const isSpecificLocationNewArr = isSpecificLocationSelected[index]?.map(
      (_, idx) => (idx === machineIndex ? select : _)
    );
    const arr = [...isSpecificLocationSelected];
    arr[index] = isSpecificLocationNewArr;

    dispatch(handleSpecificLocationSelect({ switch: swt, arr }));

    const locationIndex = locations.indexOf(option);
    const machineNewArr = isMachineSelected[locationIndex][machineIndex]?.map(
      () => select
    );
    const deepCopyArr = JSON.parse(JSON.stringify(isMachineSelected));
    deepCopyArr[locationIndex][machineIndex] = machineNewArr;
    dispatch(handleMachineSelect({ switch: swt, arr: deepCopyArr }));

    if (!select) {
      dispatch(handleSelectAll({ switch: swt, status: false }));

      const locationArr = [...isLocationSelected];
      locationArr[locationIndex] = false;
      dispatch(handleLocationSelect({ switch: swt, arr: locationArr }));

      dispatch(
        handleAddLocations({
          switch: swt,
          arr: selectedLocations.filter((el) => el !== option),
        })
      );

      selectedList.push({
        location: option,
        specificLocation: null,
        device: null,
      });
      expanded = remainingMachineDescriptors(
        option,
        data[option],
        deepCopyArr[locationIndex]
      );

      dispatch(
        handleAddMachines({
          switch: swt,
          arr: mergeMachineEntries(
            selectedMachines.filter((el) => el[1] !== extraOption),
            expanded
          ),
        })
      );
    }

    dispatch(
      handleAddSpecificLocations({
        switch: swt,
        arr: withValue(selectedSpecificLocations, extraOption, select),
      })
    );

    selectedList.push({
      location: option,
      specificLocation: extraOption,
      device: null,
    });
  } else {
    const locationIdx = locations.indexOf(option);
    let newSelectedMachineArr;
    let specLocationIdx;
    let machineIdx;

    if (extraOption) {
      specLocationIdx = Object.keys(data[option].subLocations || {}).indexOf(
        extraOption
      );
      machineIdx = Object.keys(
        getDevices(data[option].subLocations?.[extraOption])
      ).indexOf(machine);

      select =
        !isMachineSelected[locationIdx]?.[specLocationIdx]?.[machineIdx];

      dispatch(
        handleMachineSelectWithSpecLocationAlt({
          switch: swt,
          locationIdx,
          specLocationIdx,
          machineIdx,
          status: select,
        })
      );

      newSelectedMachineArr = select
        ? [...selectedMachines, [option, extraOption, machine]]
        : selectedMachines.filter(
            (el) => !sameMachine(el, [option, extraOption, machine])
          );

      selectedList.push({
        location: option,
        specificLocation: extraOption,
        device: machine,
      });
    } else {
      machineIdx = Object.keys(getDevices(data[option])).indexOf(machine);
      select = !isMachineSelected[locationIdx]?.[machineIdx];

      dispatch(
        handleMachineSelectAlt({
          switch: swt,
          locationIdx,
          machineIdx,
          status: select,
        })
      );

      newSelectedMachineArr = select
        ? [...selectedMachines, [option, machine]]
        : selectedMachines.filter((el) => !sameMachine(el, [option, machine]));

      selectedList.push({
        location: option,
        specificLocation: null,
        device: machine,
      });
    }

    if (!select) {
      dispatch(handleSelectAll({ switch: swt, status: false }));

      const locationArr = [...isLocationSelected];
      locationArr[locationIdx] = false;
      dispatch(handleLocationSelect({ switch: swt, arr: locationArr }));

      dispatch(
        handleAddLocations({
          switch: swt,
          arr: selectedLocations.filter((el) => el !== option),
        })
      );

      const nextLocationMachines = JSON.parse(
        JSON.stringify(isMachineSelected[locationIdx] ?? [])
      );
      if (extraOption) {
        nextLocationMachines[specLocationIdx][machineIdx] = select;
      } else {
        nextLocationMachines[machineIdx] = select;
      }

      selectedList.push({
        location: option,
        specificLocation: null,
        device: null,
      });
      expanded = remainingMachineDescriptors(
        option,
        data[option],
        nextLocationMachines
      );
      newSelectedMachineArr = mergeMachineEntries(
        newSelectedMachineArr,
        expanded
      );

      if (extraOption) {
        let specIdx;
        specificLocations.forEach((el, i) => {
          if (el.includes(extraOption)) {
            specIdx = i;
          }
        });

        if (specIdx !== undefined && isSpecificLocationSelected[specIdx]) {
          const specArr = JSON.parse(JSON.stringify(isSpecificLocationSelected));
          specArr[specIdx][specLocationIdx] = false;
          dispatch(handleSpecificLocationSelect({ switch: swt, arr: specArr }));
        }

        dispatch(
          handleAddSpecificLocations({
            switch: swt,
            arr: selectedSpecificLocations.filter((el) => el !== extraOption),
          })
        );
      }
    }

    dispatch(handleAddMachines({ switch: swt, arr: newSelectedMachineArr }));
  }

  return { selectedList, select, expanded };
};
